<template>
  <section class="section">
    <div class="section-body">
      <div class="card" v-if="!isEdit">
        <div class="card-header">
          <v-icon color="pink">search</v-icon>
          <h4>{{ $t("messages.general.searchShowInfo") }}</h4>
        </div>
        <div class="card-body">
          <v-card width="100%">
            <v-row>
              <v-col
                cols="10"
                style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
              >
                <p style="color: red; margin: 0">*</p>
              </v-col>
              <v-col
                style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
              >
                <p style="margin: 0">{{ $t("messages.general.reqFields") }}</p>
              </v-col>
            </v-row>
          </v-card>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.academicYear") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <AcademicYear
                      :onChanged="onSelYearChanged"
                      :selectedVal="selYear"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.semester") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Semester
                      :onChanged="onSelSemesterChanged"
                      :selectedVal="selSemester"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.educationLvl") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Level
                      :onChanged="onSelLvlChanged"
                      :selectedVal="selLvl"
                      :disabled="false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.classCode") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="input-group">
                            <div class="form-inline">
                              <div class="input-group-append">
                                <input
                                  type="text"
                                  class="form-control col mr-2"
                                  style="margin-right: 0px !important"
                                  v-model="courseCode"
                                  @keypress="handleSearchClsKey($event)"
                                />
                                <button
                                  type="button"
                                  class="btn btn-temp btn-lg"
                                  @click="handleSearchCls()"
                                >
                                  <i class="fas fa-search"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              disabled
                              v-model="courseName"
                            />
                            <button
                              type="button"
                              class="btn btn-danger btn-lg"
                              @click="handleClrCourse()"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.section") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select
                        class="form-control"
                        @change="onSelSectionChanged($event)"
                      >
                        <option :selected="selSection == '00'" value="00"
                          >---{{
                            $t("messages.general.notSpecified")
                          }}---</option
                        >
                        <option
                          v-for="(item, index) in sections"
                          :key="index"
                          :value="item.SECTION_TEXT"
                          :selected="selSection == item.SECTION_TEXT"
                        >
                          {{ item.SECTION_TEXT }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="handleSearchConfirmResult()"
                  >
                    {{ $t("messages.general.search") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-light btn-lg"
                    @click="handleClearScreen()"
                  >
                    {{ $t("messages.general.clearScreen") }}</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
          </form>
          <v-card>
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTable.sortBy"
              :sort-desc.sync="bTable.sortDesc"
              :items="bTable.items"
              :fields="bTable.fields"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTable.items.length"
                  v-model="currentPage"
                  :per-page="perPage"
                />
                <div
                  v-if="bTable.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPage > 1
                        ? (currentPage - 1) * perPage + 1
                        : currentPage
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPage * perPage > bTable.items.length
                        ? bTable.items.length
                        : currentPage * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTable.items.length).toLocaleString() }}
                </div>
                <div
                  v-if="bTable.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTable.items.length).toLocaleString() }}
                </div>
              </template>

              <template v-slot:cell(action)="data">
                <v-btn text icon @click="goTo(data.item, data.index, 'edit')">
                  <v-icon @click="goTo(data.item, data.index, 'edit')"
                    >edit</v-icon
                  >
                </v-btn>
              </template>
              <template v-slot:cell(DATETIME)="data">
                <div v-html="data.item.DATETIME">
                  {{ data.item.DATETIME }}
                </div>
              </template>
              <template v-slot:cell(INSTRUCTOR)="data">
                <div v-html="data.item.INSTRUCTOR">
                  {{ data.item.INSTRUCTOR }}
                </div>
              </template>

              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTable.items.length"
                    v-model="currentPage"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTable.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPage > 1
                          ? (currentPage - 1) * perPage + 1
                          : currentPage
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPage * perPage > bTable.items.length
                          ? bTable.items.length
                          : currentPage * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTable.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTable.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTable.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>
        </div>
      </div>
      <div class="card" v-if="isEdit">
        <div class="card-header">
          <v-icon color="pink">edit</v-icon>
          <h4>{{ $t("messages.general.manageData") }}</h4>
        </div>
        <v-card width="100%">
          <v-row>
            <v-col
              cols="10"
              style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
            >
              <p style="color: red; margin: 0">*</p>
            </v-col>
            <v-col
              style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
            >
              <p style="margin: 0">{{ $t("messages.general.reqFields") }}</p>
            </v-col>
          </v-row>
        </v-card>
        <form>
          <div class="information-block">
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.academicYear") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selected.ACADYEAR }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.semester") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selected.SEMESTER }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.educationLvl") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selLvl }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.classId") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selected.COURSECODE }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.className") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selected.COURSENAME }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.section") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selected.SECTION }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="mode == 'edit'" class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <label>{{ $t("messages.general.resultApprove") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-group" style="margin-bottom: 0;">
                      <div class="form-inline">
                        <div
                          class="custom-control custom-radio custom-control-inline"
                        >
                          <input
                            type="radio"
                            id="rdType0"
                            name="reType"
                            class="custom-control-input"
                            v-model="randomType"
                            value="A"
                          />
                          <label class="custom-control-label" for="rdType0">{{
                            $t("messages.general.notSpecified")
                          }}</label>
                        </div>
                        <div
                          class="custom-control custom-radio custom-control-inline"
                        >
                          <input
                            type="radio"
                            id="rdType1"
                            name="reType"
                            class="custom-control-input"
                            v-model="randomType"
                            value="Y"
                          />
                          <label class="custom-control-label" for="rdType1">{{
                            $t("messages.general.approve")
                          }}</label>
                        </div>
                        <div
                          class="custom-control custom-radio custom-control-inline"
                        >
                          <input
                            type="radio"
                            id="rdType2"
                            name="reType"
                            class="custom-control-input"
                            v-model="randomType"
                            value="N"
                          />
                          <label
                            class="custom-control-label"
                            style="font-size: 16px; color: #000;"
                            for="rdType2"
                            >{{ $t("messages.general.disapproved") }}</label
                          >
                        </div>
                        <div
                          class="custom-control custom-radio custom-control-inline"
                        >
                          <input
                            type="radio"
                            id="rdType3"
                            name="reType"
                            class="custom-control-input"
                            v-model="randomType"
                            value="P"
                          />
                          <label
                            class="custom-control-label"
                            style="font-size: 16px; color: #000;"
                            for="rdType3"
                            >{{ $t("messages.general.pendingApproval") }}</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="form-row flex-column justify-content-center align-items-center mt-5"
          >
            <div class="form-group">
              <div class="form-inline">
                <button
                  div
                  v-if="mode == 'edit'"
                  type="button"
                  class="btn btn-primary btn-lg"
                  @click="searchDetailByApprove()"
                >
                  {{ $t("messages.general.search") }}</button
                >&nbsp;&nbsp;&nbsp;<button
                  type="button"
                  class="btn btn-light btn-lg"
                  @click="goBack()"
                >
                  {{ $t("messages.general.backhome") }}</button
                >&nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>

          <div v-if="isEdit && mode !== 'rechkStuRegSec'" class="form-row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 10em;">
                  <label
                    >{{ $t("messages.general.movemsg") }}
                    <code style="background: none; box-shadow: none;"
                      >*</code
                    ></label
                  >
                </div>
                <div class="col no-margin-padding">
                  <div>
                    <select
                      class="form-control"
                      @change="onSelSectionChanged($event)"
                      style="width:  50%"
                    >
                      <option :selected="selSection == '00'" value="00"
                        >---{{ $t("messages.general.reqSection") }}---</option
                      >
                      <option
                        v-for="(item, index) in sections"
                        :key="index"
                        :value="item.SECTION_TEXT"
                        :selected="selSection == item.SECTION_TEXT"
                        style="width:70px"
                      >
                        {{ item.SECTION_TEXT }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-inline">
                  <div class="form-inline">
                    <button
                      type="button"
                      class="btn btn-primary btn-lg"
                      @click="rechkMoveDurClass()"
                      :disabled="
                        selSection == selected.SECTION ||
                          selSection == '00' ||
                          this.studentMoveList.length <= 0
                      "
                    >
                      {{ $t("messages.general.rechkMoveDurCls") }}</button
                    >&nbsp;&nbsp;&nbsp;
                  </div>
                </div>
              </div>
            </div>
          </div>
          <v-card
            v-if="isEdit && mode !== 'rechkStuRegSec'"
            style="height: 350px; overflowX: auto; position: relative;"
          >
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTableStudent.sortBy"
              :sort-desc.sync="bTableStudent.sortDesc"
              :items="bTableStudent.items"
              :fields="bTableStudent.fields"
              :per-page="perPage"
              :current-page="currentPageStudent"
              style="position: relative; overflowY: hidden; padding-bottom: 55px"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTableStudent.items.length"
                  v-model="currentPageStudent"
                  :per-page="perPage"
                />
                <div
                  v-if="bTableStudent.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPageStudent > 1
                        ? (currentPageStudent - 1) * perPage + 1
                        : currentPageStudent
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPageStudent * perPage > bTableStudent.items.length
                        ? bTableStudent.items.length
                        : currentPageStudent * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTableStudent.items.length).toLocaleString() }}
                </div>
                <div
                  v-if="bTableStudent.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTableStudent.items.length).toLocaleString() }}
                </div>
              </template>

              <template v-slot:head(action)="">
                <label>{{ $t("messages.general.moveDurCls") }}</label
                ><br />
                <input
                  type="checkbox"
                  id="chkAll"
                  @change="handleChkAll($event)"
                  :checked="
                    bTableStudent.items.length > 0 &&
                      bTableStudent.items.length == studentMoveList.length
                  "
                />
              </template>

              <template v-slot:cell(action)="data">
                <!-- {{data}} -->
                <input
                  type="checkbox"
                  id="chk"
                  @change="handleChk($event, data)"
                  :checked="data.item.action"
                />
              </template>

              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -7px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTableStudent.items.length"
                    v-model="currentPageStudent"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTableStudent.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPageStudent > 1
                          ? (currentPageStudent - 1) * perPage + 1
                          : currentPageStudent
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPageStudent * perPage >
                          bTableStudent.items.length
                          ? bTableStudent.items.length
                          : currentPageStudent * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableStudent.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTableStudent.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableStudent.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>
          <div v-if="isEdit && mode !== 'rechkStuRegSec'" class="form-row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 10em;">
                  <label
                    >{{ $t("messages.general.movemsg") }}
                    <code style="background: none; box-shadow: none;"
                      >*</code
                    ></label
                  >
                </div>
                <div class="col no-margin-padding">
                  <div>
                    <select
                      class="form-control"
                      @change="onSelSectionChanged($event)"
                      style="width:  50%"
                    >
                      <option :selected="selSection == '00'" value="00"
                        >---{{ $t("messages.general.reqSection") }}---</option
                      >
                      <option
                        v-for="(item, index) in sections"
                        :key="index"
                        :value="item.SECTION_TEXT"
                        :selected="selSection == item.SECTION_TEXT"
                        style="width:70px"
                      >
                        {{ item.SECTION_TEXT }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-inline">
                  <div class="form-inline">
                    <button
                      type="button"
                      class="btn btn-primary btn-lg"
                      @click="rechkMoveDurClass()"
                      :disabled="
                        selSection == selected.SECTION ||
                          selSection == '00' ||
                          this.studentMoveList.length <= 0
                      "
                    >
                      {{ $t("messages.general.rechkMoveDurCls") }}</button
                    >&nbsp;&nbsp;&nbsp;
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isEdit && mode == 'rechkStuRegSec'" class="form-row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 10em;">
                  <label
                    >{{ $t("messages.general.movemsg") }}
                    <code style="background: none; box-shadow: none;"
                      >*</code
                    ></label
                  >
                </div>
                <div class="col no-margin-padding">
                  <div>
                    <select
                      class="form-control"
                      @change="onSelSectionChanged($event)"
                      style="width:  50%"
                    >
                      <option :selected="selSection == '00'" value="00"
                        >---{{ $t("messages.general.reqSection") }}---</option
                      >
                      <option
                        v-for="(item, index) in sections"
                        :key="index"
                        :value="item.SECTION_TEXT"
                        :selected="selSection == item.SECTION_TEXT"
                        style="width:70px"
                      >
                        {{ item.SECTION_TEXT }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-inline">
                  <div class="form-inline">
                    <button
                      type="button"
                      class="btn btn-primary btn-lg"
                      @click="moveDurCls()"
                      :disabled="
                        selSection == selected.SECTION ||
                          selSection == '00' ||
                          this.studentMoveClassList.length <= 0
                      "
                    >
                      {{ $t("messages.general.moveDurCls") }}</button
                    >&nbsp;&nbsp;&nbsp;
                    <button
                      type="button"
                      class="btn btn-primary btn-lg"
                      @click="backForChk()"
                    >
                      {{ $t("messages.general.backForChk") }}</button
                    >&nbsp;&nbsp;&nbsp;
                  </div>
                </div>
              </div>
            </div>
          </div>
          <v-card
            v-if="isEdit && mode == 'rechkStuRegSec'"
            style="height: 350px; overflowX: auto; position: relative;"
          >
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTableStuRechkSec.sortBy"
              :sort-desc.sync="bTableStuRechkSec.sortDesc"
              :items="bTableStuRechkSec.items"
              :fields="bTableStuRechkSec.fields"
              :per-page="perPage"
              :current-page="currentPageStudent"
              style="position: relative; overflowY: hidden; padding-bottom: 55px"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTableStuRechkSec.items.length"
                  v-model="currentPageStudent"
                  :per-page="perPage"
                />
                <div
                  v-if="bTableStuRechkSec.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPageStudent > 1
                        ? (currentPageStudent - 1) * perPage + 1
                        : currentPageStudent
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPageStudent * perPage >
                        bTableStuRechkSec.items.length
                        ? bTableStuRechkSec.items.length
                        : currentPageStudent * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTableStuRechkSec.items.length).toLocaleString() }}
                </div>
                <div
                  v-if="bTableStuRechkSec.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTableStuRechkSec.items.length).toLocaleString() }}
                </div>
              </template>

              <template v-slot:head(action)="">
                <label>{{ $t("messages.general.moveDurCls") }}</label
                ><br />
                <input
                  type="checkbox"
                  id="chkDelAll"
                  @change="handleChkAllChkStuRechk($event)"
                  :checked="
                    bTableStuRechkSec.items.length > 0 &&
                      bTableStuRechkSec.items.length == getCntStudentReChk()
                  "
                />
              </template>
              <!-- ใส่สีตัวหนังสือนศ.ที่สามารถย้ายตอนเรียนได้ ให้แสดงสีเขียว ย้ายไม่ได้ให้แสดงตัวหนังสือสีแดง -->
              <template v-slot:cell(action)="data">
                <input
                  type="checkbox"
                  id="chkDel"
                  @change="handleChkStuRechk($event, data)"
                  :checked="data.value"
                  :disabled="data.item.ERRORID != 0"
                />
              </template>

              <template v-slot:cell(ERRORTEXT)="data">
                <label
                  :style="
                    data.item.ERRORID == 0 ? 'color: green' : 'color: red'
                  "
                  >{{ data.item.ERRORTEXT }}</label
                >
              </template>

              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -7px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTableStuRechkSec.items.length"
                    v-model="currentPageStudent"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTableStuRechkSec.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPageStudent > 1
                          ? (currentPageStudent - 1) * perPage + 1
                          : currentPageStudent
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPageStudent * perPage >
                          bTableStuRechkSec.items.length
                          ? bTableStuRechkSec.items.length
                          : currentPageStudent * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{
                      Number(bTableStuRechkSec.items.length).toLocaleString()
                    }}
                  </div>
                  <div
                    v-if="bTableStuRechkSec.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{
                      Number(bTableStuRechkSec.items.length).toLocaleString()
                    }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>
          <div v-if="isEdit && mode == 'rechkStuRegSec'" class="form-row">
            <div class="col no-padding-bottom">
              <div class="information-detail-white">
                <div class="col no-margin-padding" style="flex: 0 0 10em;">
                  <label
                    >{{ $t("messages.general.movemsg") }}
                    <code style="background: none; box-shadow: none;"
                      >*</code
                    ></label
                  >
                </div>
                <div class="col no-margin-padding">
                  <div>
                    <select
                      class="form-control"
                      @change="onSelSectionChanged($event)"
                      style="width:  50%"
                    >
                      <option :selected="selSection == '00'" value="00"
                        >---{{ $t("messages.general.reqSection") }}---</option
                      >
                      <option
                        v-for="(item, index) in sections"
                        :key="index"
                        :value="item.SECTION_TEXT"
                        :selected="selSection == item.SECTION_TEXT"
                        style="width:70px"
                      >
                        {{ item.SECTION_TEXT }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-inline">
                  <div class="form-inline">
                    <button
                      type="button"
                      class="btn btn-primary btn-lg"
                      @click="moveDurCls()"
                      :disabled="
                        selSection == selected.SECTION ||
                          selSection == '00' ||
                          this.studentMoveClassList.length <= 0
                      "
                    >
                      {{ $t("messages.general.moveDurCls") }}</button
                    >&nbsp;&nbsp;&nbsp;
                    <button
                      type="button"
                      class="btn btn-primary btn-lg"
                      @click="backForChk()"
                    >
                      {{ $t("messages.general.backForChk") }}</button
                    >&nbsp;&nbsp;&nbsp;
                  </div>
                </div>
              </div>
            </div>
          </div>
          <v-dialog
            v-model="dialogMoveDurCls"
            hide-overlay
            scrollable
            max-width="50%"
          >
            <v-card tile>
              <v-toolbar flat dense>
                <v-toolbar-title>{{ $t("ยืนยันรับแล้ว") }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogMoveDurCls = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark>
                <div class="form-row">
                  <div class="col no-padding-bottom">
                    <div class="information-detail-white">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 100em;"
                      >
                        <label>
                          {{ $t("messages.general.wanttoMoveClass")
                          }}{{ selected.COURSECODE
                          }}{{ $t("messages.general.fromSectionClass")
                          }}{{ selected.SECTION
                          }}{{ $t("messages.general.gotoClass") }}{{ selSection
                          }}{{ $t("messages.general.allStudent")
                          }}{{ getCntStudentReChk() }}
                          {{ $t("messages.general.studentAllAmount") }}
                          {{
                            $t("messages.general.confirmSaveSectionClass")
                          }}</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="form-row flex-column justify-content-center align-items-center mt-5"
                >
                  <div class="form-group">
                    <div class="form-inline">
                      <button
                        class="btn btn-primary btn-lg"
                        type="button"
                        @click="saveClassChangeSec()"
                      >
                        {{ $t("messages.general.save") }}</button
                      >&nbsp;&nbsp;&nbsp;
                      <button
                        class="btn btn-light btn-lg"
                        type="button"
                        @click="cencelsaveClassChangeSec()"
                      >
                        {{ $t("messages.general.cancel") }}</button
                      >&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </form>
      </div>
    </div>
    <v-dialog
      v-model="dialogSearchProgram"
      hide-overlay
      scrollable
      max-width="80%"
    >
      <v-card tile>
        <v-toolbar flat dense>
          <v-icon>search</v-icon>
          <v-toolbar-title>{{
            $t("messages.general.classList")
          }}</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogSearchProgram = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark>
          <!-- <v-card width="100%">
            <v-row>
              <v-col
                class="text-danger"
                style="padding-top: 0; padding-bottom: 0; padding-right: 25px;"
              >
                <p style="margin: 0; text-align: right;">
                  {{ $t("messages.general.programCodeNameReq") }}
                </p>
              </v-col>
            </v-row>
          </v-card> -->
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.classId") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <input
                        v-model="dlgCourseCode"
                        type="text"
                        class="form-control col mr-2"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.className") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <input
                        v-model="dlgCourseName"
                        type="text"
                        class="form-control col mr-2"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.faculty") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Faculty
                      :onChanged="onSelFacultyCourseChanged"
                      :selectedVal="selFacultyCourse"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.department") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Department
                      :onChanged="onSelDepartmentCourseChanged"
                      :facultyid="selFacultyCourse"
                      :selectedVal="selDepartmentCourse"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    class="btn btn-primary btn-lg"
                    type="button"
                    @click="handleCourseSearch()"
                  >
                    {{ $t("messages.general.search") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    class="btn btn-light btn-lg"
                    type="button"
                    @click="cleartCourseProgram()"
                  >
                    {{ $t("messages.general.clearScreen") }}</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
          </form>
          <v-card>
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTableProgram.sortBy"
              :sort-desc.sync="bTableProgram.sortDesc"
              :items="bTableProgram.items"
              :fields="bTableProgram.fields"
              :per-page="perPage"
              :current-page="currentPageProgram"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTableProgram.items.length"
                  v-model="currentPageProgram"
                  :per-page="perPage"
                />
                <div
                  v-if="bTableProgram.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPageProgram > 1
                        ? (currentPageProgram - 1) * perPage + 1
                        : currentPageProgram
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPageProgram * perPage > bTableProgram.items.length
                        ? bTableProgram.items.length
                        : currentPageProgram * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTableProgram.items.length).toLocaleString() }}
                </div>
                <div
                  v-if="bTableProgram.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTableProgram.items.length).toLocaleString() }}
                </div>
              </template>

              <template v-slot:cell(COURSECODE)="data">
                <a
                  @click="handleSelectCourse(data.item, data.index)"
                  style="text-decoration: underline;"
                >
                  {{ data.item.COURSECODE }}
                </a>
              </template>

              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTableProgram.items.length"
                    v-model="currentPageProgram"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTableProgram.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPageProgram > 1
                          ? (currentPageProgram - 1) * perPage + 1
                          : currentPageProgram
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPageProgram * perPage >
                          bTableProgram.items.length
                          ? bTableProgram.items.length
                          : currentPageProgram * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableProgram.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTableProgram.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableProgram.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirmSuccess" max-width="600px">
      <v-card tile>
        <v-toolbar flat dense color="light-green accent-3">
          <v-icon color="light-green darken-2">fa-check</v-icon>
          <v-toolbar-title style="color: green;"
            >&nbsp;{{
              $t("messages.reqRegister.confirmPopupText")
            }}</v-toolbar-title
          >
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogConfirmSuccess = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark color="green accent-1">
          <br />
          <span v-html="successText" style="color: green;">{{
            successText
          }}</span>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogError" max-width="600px">
      <v-card tile>
        <v-toolbar flat dense color="red darken-3">
          <v-icon color="red lighten-5">fa-exclamation-circle</v-icon>
          <v-toolbar-title style="color: #ffebee;"
            >&nbsp;{{ dialogErrorTitle }}</v-toolbar-title
          >
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogError = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark color="red accent-1">
          <br />
          <span style="color: red;" v-html="errorText">{{ errorText }}</span>
        </v-card-text>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import AcademicYear from "../components/Dropdown/AcademicYear";
import Semester from "../components/Dropdown/Semester";
import Level from "@/components/Dropdown/Level.vue";
import Faculty from "@/components/Dropdown/Faculty.vue";
import Department from "@/components/Dropdown/Department.vue";
import MasterDataProvider from "@/services/masterData_provider";
import EnrollProvider from "@/services/enroll_provider";

const masterDataProvider = new MasterDataProvider();
const enrollProvider = new EnrollProvider();

export default {
  name: "transferClassByCourse",
  components: {
    AcademicYear,
    Semester,
    Level,
    Faculty,
    Department,
  },
  data() {
    return {
      dialogMoveDurCls: false,
      dialogSearchProgram: false,
      selYear: 0,
      selSemester: 0,
      selLvl: 0,
      selSection: "00",
      courseId: "",
      courseCode: "",
      courseName: "",
      sections: [],
      items: [],
      mode: "",
      studentMoveList: [],
      studentMoveClassList: [],
      bTableStuRechkSec: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "STUDENTCODE",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            sortable: true,
          },
          {
            key: "STUDENTNAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            tdClass: "text-left",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            thStyle: "width: 130px",
            sortable: true,
          },
          {
            key: "DEPARTMENTNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "LEVELGROUP",
            label: this.$t("messages.general.educationLvl"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "ERRORTEXT",
            label: this.$t("messages.general.remark"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            thStyle: "width: 80px",
            sortable: true,
          },
          {
            key: "action",
            label: "",
            thClass: "align-middle",
            thStle: "width: 100px",
            tdClass: "col-100",
          },
        ],
      },
      bTable: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "action",
            label: "",
            thClass: "align-middle",
            thStyle: "width: 50px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "COURSECODE",
            label: this.$t("messages.general.classId"),
            thClass: "align-middle",
            thStyle: "width: 80px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "COURSENAME",
            label: this.$t("messages.general.className"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp  col-200",
            sortable: true,
          },
          {
            key: "SECTION",
            label: this.$t("messages.general.section"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "DATETIME",
            label: this.$t("messages.general.dateClassTime"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp col-150",
            sortable: true,
          },
          {
            key: "INSTRUCTOR",
            label: this.$t("messages.general.teachers"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp col-300",
            sortable: true,
          },
          {
            key: "TOTALSEAT",
            label: this.$t("messages.general.numberofOpen"),
            thClass: "align-middle",
            tdClass: "text-right text-nowarp col-300",
            sortable: true,
          },
          {
            key: "ENROLLSEAT",
            label: this.$t("messages.general.registerAmount"),
            thClass: "align-middle",
            tdClass: "text-right text-nowarp col-300",
            sortable: true,
          },
          {
            key: "AMOUNT",
            label: this.$t("messages.general.reqAmount"),
            thClass: "align-right",
            tdClass: "text-right text-nowarp  col-50",
            sortable: true,
          },
          {
            key: "CONFIRM_FLAG",
            label: this.$t("messages.general.confirmStatus"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp  col-50",
            sortable: true,
          },
          {
            key: "APPROVE_FLAG",
            label: this.$t("messages.general.approveStatus"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp  col-50",
            sortable: true,
          },
        ],
      },
      bTableStudent: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [],
      },
      bTableProgram: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "COURSECODE",
            label: this.$t("messages.general.classId"),
            thClass: "align-middle",
            thStyle: "width: 100px",
            sortable: true,
          },
          {
            key: "COURSENAME",
            label: this.$t("messages.general.className"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp col-250",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp col-150",
            sortable: true,
          },
          {
            key: "DEPARTMENTNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp col-200",
            sortable: true,
          },
          {
            key: "COURSEUNIT",
            label: this.$t("messages.general.credit"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            thStyle: "width: 100px",
            sortable: true,
          },
        ],
      },
      perPageOptions: [
        { value: 10, text: 10 },
        { value: 50, text: 50 },
        { value: 100, text: 100 },
        { value: 500, text: 500 },
        { value: 1000, text: 1000 },
        { value: 2000, text: 2000 },
        { value: 3000, text: 3000 },
      ],
      perPage: 100,
      perPageStudentReg: 50,
      currentPage: 1,
      currentPageProgram: 1,
      searched: false,
      selected: false,
      selectedIdx: 0,
      isEdit: false,
      selectedDetail: false,
      dlgCourseCode: "",
      dlgCourseName: "",
      selDepartmentCourse: 0,
      selFacultyCourse: 0,
      selectedClsId: 0,
      dialogConfirmSuccess: false,
      successText: "",
      dialogError: false,
      errorText: "",
      dialogErrorTitle: "",
      totalConfirm: "",
      currentPageStudentReg: 1,
      studentIdList: [],
      randomType: "A",
      studentListChange: [],
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
      userId: "getUserId",
      mfuUserId: "getMfuUserId",
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    },
    currentUserType: function() {
      return this.appInfo.data.USER_TYPE;
    },
  },
  mounted() {
    this.tokenHealthChk();
    this.togglePreLoader(true);
    this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
    this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
    this.selLvl = 3;
    this.selSection = "00";
    this.togglePreLoader(false);
  },
  methods: {
    ...mapActions("application", ["togglePreLoader", "tokenHealthChk"]),
    onSelYearChanged(event) {
      this.selYear = parseInt(event.target.value);
      this.getSections();
    },
    onSelSemesterChanged(event) {
      this.selSemester = parseInt(event.target.value);
      this.getSections();
    },
    onSelLvlChanged(event) {
      this.selLvl = parseInt(event.target.value);
    },
    onSelSectionChanged(event) {
      this.selSection = event.target.value;
    },
    onSelFacultyCourseChanged() {
      this.selFacultyCourse = parseInt(event.target.value);
    },
    onSelDepartmentCourseChanged(event) {
      this.selDepartmentCourse = parseInt(event.target.value);
    },
    handleSearchClsKey(event) {
      if (event.charCode == 13) {
        this.handleSearchCls();
      }
    },
    async handleSearchCls() {
      if (this.courseCode != "") {
        this.togglePreLoader(true);
        const result = await enrollProvider.getCourseByAcad({
          token: this.token,
          request: {
            coursecode: this.courseCode,
            acadyear: this.selYear,
            semester: this.selSemester,
            levelid: this.selLvl,
            lang: this.currentLang,
          },
        });
        // Fix Dropdown Course List Found Multiple Course
        if (result.code != 500 && result.data.length > 0) {
          if (
            result.data.length == 1 ||
            result.data[0].COURSECODE == this.courseCode
          ) {
            this.handleSelectClass(result.data[0]);
            this.courseList = result;
          } else {
            this.courseList = result;
            this.dlgCourseCode = this.courseCode;
            this.dialogSearchProgram = true;
            this.bTableProgram.items = [];
            if (result.data.length > 0) {
              let idx = 0;
              result.data.map((d) => {
                d.rowNumber = idx + 1;
                this.bTableProgram.items.push(d);
                idx++;
              });
            }
          }
        } else {
          this.dialogError = true;
          this.errorText = result.message;
        }
        this.togglePreLoader(false);
      } else {
        this.handleShowDlgSearchCourse();
      }
    },
    handleClrCourse() {
      this.courseId = "";
      this.courseCode = "";
      this.courseName = "";
      this.sections = [];
    },
    async handleSelectClass(item) {
      if (item && item.COURSECODE != null) {
        this.courseId = item.COURSEID;
        this.courseCode = item.COURSECODE;
        this.courseName = item.COURSENAME;
        await this.getSections();
      }
    },
    handleChkAll(e) {
      const isChecked = e.target.checked;
      this.bTableStudent.items.map((i) => {
        i.action = e.target.checked;
        if (isChecked) {
          this.studentMoveList.push(i);
        }
      });
      if (!isChecked) {
        this.studentMoveList = [];
      }
    },
    handleChk(e, data) {
      const isChecked = e.target.checked;
      const { item, index } = data;
      this.bTableStudent.items[index].action = isChecked;
      if (isChecked) {
        this.studentMoveList.push(item);
      } else {
        const newArr = this.studentMoveList.filter(
          (s) => s.STUDENTCODE != item.STUDENTCODE
        );
        this.studentMoveList = newArr;
      }
    },
    handleChkAllChkStuRechk(e) {
      const isChecked = e.target.checked;
      this.bTableStuRechkSec.items.map((i) => {
        if (i.ERRORID == 0) {
          i.action = e.target.checked;
          if (isChecked) {
            this.studentMoveClassList.push(i.STUDENTID);
          }
        } else {
          i.action = false;
        }
      });
      if (!isChecked) {
        this.studentMoveClassList = [];
      }
    },
    getCntStudentReChk() {
      let cnt = 0;
      this.bTableStuRechkSec.items.forEach((d) => {
        if (d.action == true) {
          cnt++;
        }
      });
      return cnt;
    },
    handleChkStuRechk(e, data) {
      const isChecked = e.target.checked;
      const { item, index } = data;
      this.bTableStuRechkSec.items[index].action = isChecked;
      if (isChecked) {
        this.studentMoveClassList.push(item.CLASSID);
      } else {
        const newArr = this.studentMoveClassList.filter(
          (s) => s != item.STUDENTID
        );
        this.studentMoveClassList = newArr;
      }
    },
    async getSections() {
      if (this.selYear != 0 && this.selSemester != 0 && this.courseCode != "") {
        this.togglePreLoader(true);
        const data = await masterDataProvider.getSection({
          token: this.token,
          request: {
            acadyear: this.selYear,
            semester: this.selSemester,
            coursecode: this.courseCode,
            lang: this.currentLang,
          },
        });
        this.sections = data;
        this.togglePreLoader(false);
      }
    },
    async handleSearchConfirmResult() {
      if (this.selYear != 0 && this.selSemester != 0 && this.selLvl != -1) {
        this.togglePreLoader(true);

        //แปลงค่า coursecode จากหน้าจอฟิวรายวิชากรณีไม่ได้กด enter หรือปุ่มแว่นขยาย ให้เป็นค่า courseid เพื่อนำค่าส่งไปยังปุ่มค้นหา
        if (this.courseCode != "") {
          this.togglePreLoader(true);
          const reg = await enrollProvider.getCourseByAcad({
            token: this.token,
            request: {
              coursecode: this.courseCode,
              acadyear: this.selYear,
              semester: this.selSemester,
              levelid: this.selLvl,
              lang: this.currentLang,
            },
          });
          // console.log("reg handleSearchConfirmResult",reg);

          if (reg.code != 500 && reg.data.length > 0) {
            if (
              reg.data.length == 1 ||
              reg.data[0].COURSECODE == this.courseCode
            ) {
              this.handleSelectClass(reg.data[0]);
            }
          }
        }
        const result = await enrollProvider.classprechangebycoursesel({
          token: this.token,
          request: {
            acadyear: this.selYear,
            semester: this.selSemester,
            levelid: this.selLvl,
           // courseid: this.courseCode,
           courseid: this.courseId,
            section: this.selSection,
            userid: this.mfuUserId,
            lang: this.currentLang,
          },
        });
        this.bTable.items = [];
        if (result.length > 0) {
          this.searched = true;
          let idx = 0;
          result.map((d) => {
            d.rowNumber = idx + 1;
            if (d.INSTRUCTOR) {
              d.INSTRUCTOR = d.INSTRUCTOR.replace(/\|/g, "<br/>");
            }
            if (d.DATETIME) {
              d.DATETIME = d.DATETIME.replace(/\|/g, "</br>");
            }
            this.bTable.items.push(d);
            idx++;
          });
        }
        this.togglePreLoader(false);
      }
    },
    async searchDetailByApprove() {
      this.togglePreLoader(true);
      const result = await enrollProvider.classprechangebystudent({
        token: this.token,
        request: {
          acadyear: this.selected.ACADYEAR,
          semester: this.selected.SEMESTER,
          courseid: this.selected.COURSEID,
          section: this.selected.SECTION,
          approve_status: this.randomType,
          userid: this.mfuUserId,
          lang: this.currentLang,
        },
      });
      this.togglePreLoader(false);
      this.bTableStudent.items = [];
      if (result.length > 0) {
        const temp = result.map((r, index) => {
          return {
            rowNumber: index + 1,
            ...r,
          };
        });
        this.bTableStudent.items = temp;
      }
      this.isEdit = true;
    },
    async saveClassChangeSec() {
      this.togglePreLoader(true);
      const selTemp = this.bTableStuRechkSec.items
        .filter((d) => d.action == true)
        .map((dd) => +dd.STUDENTCODE);
      const resIp = await masterDataProvider.getCurrentIP();
      const temp = {
        token: this.token,
        request: {
          studentid_list: selTemp,
          classid_old: this.selected.CLASSID,
          acadyear: this.selected.ACADYEAR,
          semester: this.selected.SEMESTER,
          levelid: this.selLvl,
          courseid: this.selected.COURSEID,
          section: this.selSection,
          ipaddress: resIp.ip,
          submit_userid: this.mfuUserId,
          lang: this.currentLang,
        },
      };
      const result = await enrollProvider.saveClassprechangebycoursestu(temp);
      if (result.status == 200) {
        this.dialogConfirmSuccess = true;
        this.successText = `${result.message}<br/>`;
        this.dialogMoveDurCls = false;
        this.handleSearchConfirmResult();
        this.isEdit = false;
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${result.message}`;
      }
      this.togglePreLoader(false);
    },
    cencelsaveClassChangeSec() {
      this.dialogMoveDurCls = false;
    },
    async getReqConfirmDetail() {
      //if (this.selected) {
      this.togglePreLoader(true);
      const result = await enrollProvider.classprechangebystudent({
        token: this.token,
        request: {
          acadyear: this.selYear,
          semester: this.selSemester,
          courseid: this.selected.COURSEID,
          section: this.selected.SECTION,
          approve_status: "A",
          userid: this.mfuUserId,
          lang: this.currentLang,
        },
      });
      this.togglePreLoader(false);
      if (result.length > 0) {
        this.selectedDetail = result[0];
        this.bTableStudent.items = [];
        const temp = result.map((r, index) => {
          return {
            rowNumber: index + 1,
            ...r,
          };
        });
        this.bTableStudent.items = temp;
        this.isEdit = true;
      }
      // }
    },
    handleClearScreen() {
      this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
      this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
      this.selLvl = 3;
      this.selSection = "00";
      this.handleClrCourse();
      this.selected = false;
      this.searched = false;
      this.selectedIdx = 0;
      this.bTable.items = [];
    },
    moveDurCls() {
      this.dialogMoveDurCls = true;
    },
    rechkMoveDurClass() {
      this.goTo(-1, -1, "rechkStuRegSec");
    },
    backForChk() {
      this.studentMoveClassList = [];
      this.goTo(-1, -1, "editback");
    },
    async goTo(item, index, mode) {
      this.mode = mode;
      if (mode == "edit" || mode == "editback") {
        if (mode == "edit") {
          this.selected = item;
          this.selectedIdx = index;
          this.selectedClsId = item.CLASSID;
          this.getReqConfirmDetail();
          const data = await masterDataProvider.getSection({
            token: this.token,
            request: {
              acadyear: this.selYear,
              semester: this.selSemester,
              coursecode: item.COURSECODE,
              lang: this.currentLang,
            },
          });
          this.sections = data;
        } else {
        }
        this.bTableStudent.fields = [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "STUDENTCODE",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            sortable: true,
          },
          {
            key: "STUDENTNAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            tdClass: "text-left",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            thStyle: "width: 130px",
            sortable: true,
          },
          {
            key: "DEPARTMENTNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp col-200",
            sortable: true,
          },
          {
            key: "LEVELGROUP",
            label: this.$t("messages.general.educationLvl"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "TIMEFLAG",
            label: this.$t("messages.general.confirm"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            thStyle: "width: 80px",
            sortable: true,
          },
          {
            key: "APPROVE_FLAG",
            label: this.$t("messages.general.resultApprove"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "action",
            label: "",
            thClass: "align-middle",
            thStle: "width: 100px",
            tdClass: "col-100",
          },
        ];
        this.isEdit = true;
      } else if (mode == "rechkStuRegSec") {
        this.saveClassPreChangebyCoursesChk();
        this.isEdit = true;
      } else {
        console.log("goto mode", mode);
      }
    },
    async saveClassPreChangebyCoursesChk() {
      this.togglePreLoader(true);
      const resIp = await masterDataProvider.getCurrentIP();
      const data = await enrollProvider.classprechangebystubysec({
        token: this.token,
        request: {
          acadyear: this.selYear,
          semester: this.selSemester,
          courseid: this.selected.COURSEID,
          studentid: this.studentMoveList[0].STUDENTCODE,
          lang: this.currentLang,
        },
      });
      const newClassItem = data.find((d) => d.SECTION == +this.selSection);
      const temp = {
        token: this.token,
        request: {
          studentid_list: this.studentMoveList.map((s) => s.STUDENTCODE),
          acadyear: this.selected.ACADYEAR,
          semester: this.selected.SEMESTER,
          classid_old: this.selected.CLASSID,
          classid_new: newClassItem.CLASSID,
          // pre_reg_hd_id: this.studentMoveList[0].PRE_REG_HD_ID,
          // pre_reg_dtl_id: this.studentMoveList[0].PRE_REG_DTL_ID,
          user_type: this.currentUserType,
          submit_userid: this.mfuUserId,
          submitip: resIp.ip,
          lang: this.currentLang,
        },
      };
      temp.request.studentid_list = this.studentMoveList.map((s) => {
        return +s.STUDENTCODE;
      });
      const result = await enrollProvider.saveClassprechangebycourseschk(temp);
      const tempRes = result.data.map((d, idx) => {
        return {
          ...d,
          action: false,
          rowNumber: idx + 1,
        };
      });
      this.bTableStuRechkSec.items = tempRes;

      if (result.code == 200 || result.code == 403) {
        this.dialogConfirmSuccess = true;
        this.successText = `${result.message}<br/>`;
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${result.message}`;
      }
      this.togglePreLoader(false);
    },
    goBack() {
      this.selected = false;
      this.selectedDetail = false;
      this.isEdit = false;
      this.selSection = "00";
      this.randomType = "A";
      this.bTableStudent.items = [];
      this.handleSearchConfirmResult();
      this.mode = "";
    },
    handleShowDlgSearchCourse() {
      this.cleartCourseProgram();
      this.dialogSearchProgram = true;
    },
    async handleCourseSearch() {
      // if (this.dlgCourseCode != "" || this.dlgCourseName != "") {
      this.togglePreLoader(true);
      const result = await enrollProvider.getCourseByAcad({
        token: this.token,
        request: {
          coursecode: this.dlgCourseCode,
          coursename: this.dlgCourseName,
          facultyid: this.selFacultyCourse,
          departmentid: this.selDepartmentCourse,
          acadyear: this.selYear,
          semester: this.selSemester,
          levelid: this.selLvl,
          lang: this.currentLang,
        },
      });
      this.bTableProgram.items = [];
      if (result.code != 500 && result.data.length > 0) {
        let idx = 0;
        result.data.map((d) => {
          d.rowNumber = idx + 1;
          this.bTableProgram.items.push(d);
          idx++;
        });
      } else {
        this.dialogError = true;
        this.errorText = result.message;
      }
      this.togglePreLoader(false);
      // } else {
      //   this.dialogError = true;
      //   this.errorText = this.$t("messages.general.programCodeNameReq");
      // }
    },
    cleartCourseProgram() {
      this.dlgCourseCode = "";
      this.dlgCourseName = "";
      this.selFacultyCourse = 0;
      this.selDepartmentCourse = 0;
      this.bTableProgram.items = [];
    },
    async handleSelectCourse(item, idx) {
      console.log(idx);
      this.courseCode = item.COURSECODE;
      this.courseName = item.COURSENAME;
      this.handleSelectClass(item); //ส่งค่า courseid ปุ่มฟ้า
      await this.getSections();
      this.dialogSearchProgram = false;
    },
  },
  watch: {
    currentLang() {
      this.bTableProgram.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "COURSECODE",
          label: this.$t("messages.general.classId"),
          thClass: "align-middle",
          thStyle: "width: 100px",
          sortable: true,
        },
        {
          key: "COURSENAME",
          label: this.$t("messages.general.className"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp col-250",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp col-150",
          sortable: true,
        },
        {
          key: "DEPARTMENTNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp col-200",
          sortable: true,
        },
        {
          key: "COURSEUNIT",
          label: this.$t("messages.general.credit"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          thStyle: "width: 100px",
          sortable: true,
        },
      ];
      this.bTableStudent.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "STUDENTCODE",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          sortable: true,
        },
        {
          key: "STUDENTNAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          thStyle: "width: 130px",
          sortable: true,
        },
        {
          key: "DEPARTMENTNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp col-200 ",
          sortable: true,
        },
        {
          key: "LEVELGROUP",
          label: this.$t("messages.general.educationLvl"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "TIMEFLAG",
          label: this.$t("messages.general.confirm"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          thStyle: "width: 80px",
          sortable: true,
        },
        {
          key: "APPROVE_FLAG",
          label: this.$t("messages.general.resultApprove"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "action",
          label: "",
          thClass: "align-middle",
          thStle: "width: 100px",
          tdClass: "col-100",
        },
      ];
      this.bTableStuRechkSec.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "STUDENTCODE",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          sortable: true,
        },
        {
          key: "STUDENTNAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          thStyle: "width: 130px",
          sortable: true,
        },
        {
          key: "DEPARTMENTNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "LEVELGROUP",
          label: this.$t("messages.general.educationLvl"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "ERRORTEXT",
          label: this.$t("messages.general.remark"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          thStyle: "width: 80px",
          sortable: true,
        },
        {
          key: "action",
          label: "",
          thClass: "align-middle",
          thStle: "width: 100px",
          tdClass: "col-100",
        },
      ];
      this.bTable.fields = [
        {
          key: "action",
          label: "",
          thClass: "align-middle",
          thStyle: "width: 50px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "COURSECODE",
          label: this.$t("messages.general.classId"),
          thClass: "align-middle",
          thStyle: "width: 80px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "COURSENAME",
          label: this.$t("messages.general.className"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp  col-200",
          sortable: true,
        },
        {
          key: "SECTION",
          label: this.$t("messages.general.section"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "DATETIME",
          label: this.$t("messages.general.dateClassTime"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp col-150",
          sortable: true,
        },
        {
          key: "INSTRUCTOR",
          label: this.$t("messages.general.teachers"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp col-300",
          sortable: true,
        },
        {
          key: "TOTALSEAT",
          label: this.$t("messages.general.numberofOpen"),
          thClass: "align-middle",
          tdClass: "text-right text-nowarp col-300",
          sortable: true,
        },
        {
          key: "ENROLLSEAT",
          label: this.$t("messages.general.registerAmount"),
          thClass: "align-middle",
          tdClass: "text-right text-nowarp col-300",
          sortable: true,
        },
        {
          key: "AMOUNT",
          label: this.$t("messages.general.reqAmount"),
          thClass: "align-right",
          tdClass: "text-right text-nowarp  col-50",
          sortable: true,
        },
        {
          key: "CONFIRM_FLAG",
          label: this.$t("messages.general.confirmStatus"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp  col-50",
          sortable: true,
        },
        {
          key: "APPROVE_FLAG",
          label: this.$t("messages.general.approveStatus"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp  col-50",
          sortable: true,
        },
      ];
    },
  },
};
</script>
